import { FC, useMemo } from 'react';
import { Bar, BarChart, CartesianGrid, XAxis, YAxis, ResponsiveContainer } from 'recharts';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { cn } from '@/lib/utils';
import { ChartConfig } from '@/components/ui/chart';
import { ChartHelper } from '@/utils/ChartHelper';

type Segment = {
    value: number;
    color: string;
    label: string;
};

type Props = {
    data: Segment[];
    isLoading?: boolean;
};

const AnalyticsDetailsWaterfallChart: FC<Props> = ({ data, isLoading }) => {
    const chartData = useMemo(() => {
        let cumulative = 0;

        return data.map((seg) => {
            const base = cumulative;
            cumulative += seg.value;

            return {
                base,
                ...seg,
            };
        });
    }, [data]);

    // const maxCumulative = Math.max(...chartData.map((d) => d.base + d.value), 0);
    const maxCumulative = Math.max(...chartData.map((d) => d.value), 0);

    const maxValue = isLoading ? 100 : ChartHelper.getNiceMaxValue(maxCumulative);

    const loadingData = [
        { base: 0, value: 40, color: '#EAEAEA', label: '' },
        { base: 0, value: 90, color: '#EAEAEA', label: '' },
        { base: 0, value: 20, color: '#EAEAEA', label: '' },
        { base: 0, value: 60, color: '#EAEAEA', label: '' },
    ];

    const finalData = isLoading ? loadingData : chartData;

    return (
        <div className="w-full h-60">
            <ChartContainer config={{} as ChartConfig} className="w-full h-full">
                <ResponsiveContainer width="100%" height="240px">
                    <BarChart data={finalData} className={cn(isLoading && 'animate-pulse')}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                            dataKey="label"
                            tickLine={{ stroke: '#EAEAEA' }}
                            axisLine={{ stroke: '#EAEAEA' }}
                            tick={{ fontSize: 12 }}
                        />
                        <YAxis
                            scale="linear"
                            domain={[0, maxValue]}
                            tickLine={{ stroke: '#EAEAEA' }}
                            axisLine={{ stroke: '#EAEAEA' }}
                            tick={{ fontSize: 12 }}
                            tickFormatter={(value) => value.toFixed()}
                        />
                        <ChartTooltip
                            content={
                                <ChartTooltipContent
                                    formatter={(value, _, item) =>
                                        item.dataKey === 'base'
                                            ? null
                                            : `value: ${Number(value).toFixed(2)}`
                                    }
                                />
                            }
                        />
                        {/* <Bar dataKey="base" stackId="a" fill="transparent" tooltipType="none" /> */}
                        <Bar
                            dataKey="value"
                            stackId="a"
                            radius={[8, 8, 0, 0]}
                            maxBarSize={18}
                            isAnimationActive={!isLoading}
                            // eslint-disable-next-line
                            shape={(props: any) => {
                                const { x, y, width, height, payload } = props;
                                return (
                                    <rect
                                        x={x}
                                        y={y}
                                        width={width}
                                        height={height}
                                        rx={8}
                                        ry={8}
                                        fill={payload.color}
                                    />
                                );
                            }}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </ChartContainer>
        </div>
    );
};

export default AnalyticsDetailsWaterfallChart;
